import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import InfoIconMDI from 'mdi-react/InformationOutlineIcon';
import './price-notice.scss';

const styles = bemGenerator('pj-ui-price-notice', ['icon', 'text']);

const InfoIcon = styled(InfoIconMDI).attrs(p => ({
  color:
    p.tonedown === 'true' ? p.theme.icons.quaternary : p.theme.icons.tertiary,
}))``;

const TYPES = [
  'normal',
  'not_in_mint_condition',
  'consumer_warnings_received',
  'call_for_information',
  'not_available_for_purchase',
  'used_product',
  'classified',
  'download',
  'price_in_physical_store',
  'pickup_only',
  'price_might_be_wrong',
];

// eslint-disable-next-line react/prefer-stateless-function
class PriceNotice extends React.PureComponent {
  render() {
    const { t } = this.context;
    const { type, toneDown, textAtBottom, centerAlign, tooltip } = this.props;

    if (type === 'normal') return null;

    return (
      <div
        className={styles.block.withModifier({
          'center-align': centerAlign,
          'tone-down': toneDown,
        })}
      >
        <InfoIcon tonedown={toneDown ? 'true' : 'false'} size={16} />
        <span
          className={styles.text.withModifier({
            bottom: textAtBottom,
            right: !textAtBottom,
          })}
        >
          {t('product', `price-notice.${type}`)}
        </span>
        {tooltip}
      </div>
    );
  }
}

const { oneOf, bool, node } = PropTypes;

PriceNotice.propTypes = {
  type: oneOf(TYPES).isRequired,
  toneDown: bool,
  textAtBottom: bool,
  centerAlign: bool,
  tooltip: node,
};

PriceNotice.defaultProps = {
  toneDown: false,
  textAtBottom: true,
  centerAlign: true,
  tooltip: undefined,
};

PriceNotice.contextType = AppContext;

export default PriceNotice;
